// @flow
import type { DaySummary, Sample, SampleList } from "../../lib/OnlineTypes";
import React, { Fragment } from "react";
import ReactHoverObserver from "react-hover-observer";
import Expander from "../Expander";
import styled, { css } from "styled-components";
import { Container, Row, Col } from "react-grid-system";
import Samples from "./Samples";
import { DefaultPaddedContainer } from "./Theme";
import { smallDate } from "../../lib/DateFormatting";

// const DefaultPaddedContainer = styled.div`
//   border-bottom: 1px solid #aaa;
//   border-top: 1px solid #aaa;
//   border-radius: 10px;
//   padding: 20px;
// `;

const containerStyle = {
  paddingLeft: 0,
  paddingRight: 0
};
const Cell = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #ddd;
  text-align: center;
  background-color: white;
  ${props => props.last && css``};
`;
const SamplesContainer = styled(DefaultPaddedContainer)`
  border-radius: 0px;
  box-shadow: 0px 8px 6px -6px #bbbaba;
  margin-bottom: 2px;
  OverflowTd
`;
const Fill = styled.div``;
const LeftFill = styled(Fill)`
  width: 100%;
  padding-top: 11px;
  padding-bottom: 10px;
`;
const RightFill = styled(Fill)`
  width: 100%;
  padding-top: 11px;
  padding-bottom: 10px;
`;
const DataCell = styled(Cell)`
  &:hover {
    cursor: pointer;
  }
  ${props =>
    props.isHovering &&
    !props.expanded &&
    css`
      background-color: #f2fcf2;
    `};
  ${props =>
    props.expanded &&
    css`
      background-color: #77c77a;
      font-weight: bold;
      color: white;
    `};
`;
const CountCell = styled(DataCell)`
  color: #dddddd;
`;
const FailedCountCell = styled(CountCell)`
  ${props =>
    props.count > 0 &&
    css`
      color: red;
      font-weight: bold;
    `}
`;
const WarningCountCell = styled(CountCell)`
  ${props =>
    props.count > 0 &&
    css`
      color: orange;
      font-weight: bold;
    `}
`;

type Props = {
  date: DaySummary,
  loadSamplesForDate: Object => Promise<Array<Sample>>,
  company_id: ?number,
  clientView: boolean,
  setSampleList: Function
};

type State = {
  expand: boolean,
  sample_list: SampleList
};
export default class SummaryRow extends React.Component {
  static defaultProps = {
    clientView: true
  };
  state = {
    expand: false,
    sample_list: null
  };

  toggleExpand = () => {
    const { expand } = this.state;
    if (expand) {
      this.setState({ expand: false });
    } else {
      this.props.loadSamplesForDate();
    }
  };

  // findSamples = () => {
  //   const { date, loadSamplesForDate } = this.props;
  //   loadSamplesForDate(date.date);
  // };

  render() {
    const { expand, sample_list } = this.state;
    const { date, company_id, clientView } = this.props;
    const formattedDate = smallDate(date.date);
    return (
      <Fragment>
        <Container fluid style={containerStyle} onClick={this.toggleExpand}>
          <ReactHoverObserver>
            {({ isHovering }) => (
              <Row nogutter>
                <Col sm={1}>
                  <LeftFill>&nbsp;</LeftFill>
                </Col>
                <Col sm={2}>
                  <DataCell isHovering={isHovering} expanded={expand}>
                    <Expander expanded={expand} />
                    &nbsp;&nbsp; {formattedDate}
                  </DataCell>
                </Col>
                <Col sm={2}>
                  <DataCell isHovering={isHovering} expanded={expand}>
                    {date.samples_registered} / {date.samples_received}
                  </DataCell>
                </Col>
                <Col sm={2}>
                  <DataCell last isHovering={isHovering} expanded={expand}>
                    {date.test_count}
                  </DataCell>
                </Col>
                <Col sm={1}>
                  <FailedCountCell
                    count={date.pass_fail_count}
                    last
                    isHovering={isHovering}
                    expanded={expand}
                  >
                    {date.pass_fail_count}
                  </FailedCountCell>
                </Col>
                <Col sm={1}>
                  <WarningCountCell
                    count={date.warning_count}
                    last
                    isHovering={isHovering}
                    expanded={expand}
                  >
                    {date.warning_count}
                  </WarningCountCell>
                </Col>
                <Col sm={2}>
                  <DataCell last isHovering={isHovering} expanded={expand}>
                    {date.total_price}
                  </DataCell>
                </Col>
                <Col sm={1}>
                  <RightFill>&nbsp;</RightFill>
                </Col>
              </Row>
            )}
          </ReactHoverObserver>
        </Container>
        {expand && (
          <SamplesContainer>
            <Samples
              sample_list={sample_list}
              company_id={company_id}
              showAttributes={false}
              clientView={clientView}
            />
          </SamplesContainer>
        )}
      </Fragment>
    );
  }
}
